import { render, staticRenderFns } from "./CodeInputComponent.vue?vue&type=template&id=53504db2&scoped=true&"
import script from "./CodeInputComponent.vue?vue&type=script&lang=js&"
export * from "./CodeInputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53504db2",
  null
  
)

export default component.exports